import { helpPaths, helpCentreLocaleCodes } from './helpLinks.constants';

export type HelpPathKeys = keyof typeof helpPaths;

export type Environments = 'live' | 'test' | 'development' | 'integration';

export type getHelpLinkParams = {
  key: HelpPathKeys;
  locale: string;
  environment?: Environments;
  zendeskToken?: string;
};

export type GetAllHelplinksParams = {
  locale: string;
  environment?: Environments;
  zendeskToken?: string;
};

export type getHelpLoginLinkParams = {
  environment?: Environments;
  zendeskToken: string;
};

export type TranslatedHelpLinks = Record<HelpPathKeys, string>;
export type HelpCentreLocaleCodesType = keyof typeof helpCentreLocaleCodes;
